import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import download from 'downloadjs';

export default {
  name: 'Download Files From Server',
  components: {
    download,
    VueElementLoading
  },
  data: function() {
    return {
      list: '',
      modalShow:false,
      url:'',

    }
  },
  filters: {
  },
  created: function() {},
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail[0].email;
		this.currenthubid =userdetail[0].HubId[0];
    this.listFroms3bucket();
  },
  methods: {
    listFroms3bucket() {
      this.isLoading = true
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'listFroms3bucket',
          headers: {
              'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            this.list = result.data.ResponseData;
          }
          else {
            this.list='';
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false
          console.error(error);
        })
    },
    download(list) {
      this.isLoading = true
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'downloadImageFroms3bucket?ImageUrlpath=' + list,
          headers: {
              'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            this.url=result.data.ResponseData
            var link = document.createElement('a');
						link.href = result.data.ResponseData;
						link.download = this.url.concat('.jpg');
						link.setAttribute('target','_blank');
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
          }
          else {
            this.url='';
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
          this.isLoading = false
        })
    },

    reset() {
      this.$validator.reset();
      this.list = '';
      this.url='';
      this.isLoading = false;
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/Downloads3bucketfiles/Downloads3bucketfiles.js